import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import * as Permissions from '@/js/libs/generated/permissions/types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export const getCurrentUser = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-permissions/users/current-user';
    const pathInternal = '/api/users/current-user';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false
            ? params.selectedCompanyId
            : (params.selectedCompanyId ?? queryDefaults?.['selectedCompanyId']);
        if (value !== undefined) {
            urlParams.append('selectedCompanyId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCurrentUser.paramsOrder = [{ type: 'parameters' }];
export const getUserByEmailWithPermissions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.email === undefined) {
        throw new Error('Missing required parameter: email');
    }
    const path = '/api/ws-permissions/user-with-permissions/by-email';
    const pathInternal = '/api/user-with-permissions/by-email';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.email !== undefined) {
        urlParams.append('email', params.email.toString());
    }
    {
        const value = queryDefaults === false
            ? params.selectedCompanyId
            : (params.selectedCompanyId ?? queryDefaults?.['selectedCompanyId']);
        if (value !== undefined) {
            urlParams.append('selectedCompanyId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUserByEmailWithPermissions.paramsOrder = [{ type: 'parameters' }];
export const getUserAdministratingCompanies = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.userId === undefined) {
        throw new Error('Missing required parameter: userId');
    }
    const path = '/api/ws-permissions/users/{userId}/administrating-companies'.replaceAll('{userId}', () => encodeURIComponent(String(params.userId)));
    const pathInternal = '/api/users/{userId}/administrating-companies'.replaceAll('{userId}', () => encodeURIComponent(String(params.userId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUserAdministratingCompanies.paramsOrder = [{ type: 'parameters' }];
export const updateAdministratingCompanies = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.userId === undefined) {
        throw new Error('Missing required parameter: userId');
    }
    if (params.companyIds === undefined) {
        throw new Error('Missing required body: companyIds');
    }
    const path = '/api/ws-permissions/users/{userId}/administrating-companies'.replaceAll('{userId}', () => encodeURIComponent(String(params.userId)));
    const pathInternal = '/api/users/{userId}/administrating-companies'.replaceAll('{userId}', () => encodeURIComponent(String(params.userId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyIds !== undefined) {
        body = params.companyIds;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
updateAdministratingCompanies.paramsOrder = [
    { type: 'body', paramName: 'companyIds' },
    { type: 'parameters' },
];
export const updateCompanyAccounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.accountIds === undefined) {
        throw new Error('Missing required body: accountIds');
    }
    const path = '/api/ws-permissions/companies/{companyId}/accounts'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    const pathInternal = '/api/companies/{companyId}/accounts'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountIds !== undefined) {
        body = params.accountIds;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
updateCompanyAccounts.paramsOrder = [{ type: 'body', paramName: 'accountIds' }, { type: 'parameters' }];
export const updateCompanyWebsites = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.websiteIds === undefined) {
        throw new Error('Missing required body: websiteIds');
    }
    const path = '/api/ws-permissions/companies/{companyId}/websites'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    const pathInternal = '/api/companies/{companyId}/websites'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.websiteIds !== undefined) {
        body = params.websiteIds;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
updateCompanyWebsites.paramsOrder = [{ type: 'body', paramName: 'websiteIds' }, { type: 'parameters' }];
export const getCompanyPermissions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-permissions/companies/{companyId}/permissions'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    const pathInternal = '/api/companies/{companyId}/permissions'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyPermissions.paramsOrder = [{ type: 'parameters' }];
export const updateCompanyPermissions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-permissions/companies/{companyId}/permissions'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    const pathInternal = '/api/companies/{companyId}/permissions'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
updateCompanyPermissions.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const getCompaniesPermissions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyIds === undefined) {
        throw new Error('Missing required parameter: companyIds');
    }
    const path = '/api/ws-permissions/companies/permissions/by-ids';
    const pathInternal = '/api/companies/permissions/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyIds !== undefined) {
        urlParams.append('companyIds', params.companyIds.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompaniesPermissions.paramsOrder = [{ type: 'parameters' }];
export const getCompanyPermissionsIncludeInactive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-permissions/companies/{companyId}/permissions/include-inactive'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    const pathInternal = '/api/companies/{companyId}/permissions/include-inactive'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyPermissionsIncludeInactive.paramsOrder = [{ type: 'parameters' }];
export const hasCompanyPermission = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.permission === undefined) {
        throw new Error('Missing required parameter: permission');
    }
    const path = '/api/ws-permissions/companies/{companyId}/permissions/check'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    const pathInternal = '/api/companies/{companyId}/permissions/check'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.permission !== undefined) {
        urlParams.append('permission', params.permission.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
hasCompanyPermission.paramsOrder = [{ type: 'parameters' }];
export const hasCompanyPermissionByUUID = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyUUID === undefined) {
        throw new Error('Missing required parameter: companyUUID');
    }
    if (params.permission === undefined) {
        throw new Error('Missing required parameter: permission');
    }
    const path = '/api/ws-permissions/companies/{companyUUID}/permissions/check-by-uuid'.replaceAll('{companyUUID}', () => encodeURIComponent(String(params.companyUUID)));
    const pathInternal = '/api/companies/{companyUUID}/permissions/check-by-uuid'.replaceAll('{companyUUID}', () => encodeURIComponent(String(params.companyUUID)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.permission !== undefined) {
        urlParams.append('permission', params.permission.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
hasCompanyPermissionByUUID.paramsOrder = [{ type: 'parameters' }];
export const getAllManagingCompaniesIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.permissions === undefined) {
        throw new Error('Missing required parameter: permissions');
    }
    const path = '/api/ws-permissions/companies/{companyId}/managing-companies-ids'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    const pathInternal = '/api/companies/{companyId}/managing-companies-ids'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.permissions !== undefined) {
        urlParams.append('permissions', params.permissions.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllManagingCompaniesIds.paramsOrder = [{ type: 'parameters' }];
export const getAllManagingCompaniesNames = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.permissions === undefined) {
        throw new Error('Missing required parameter: permissions');
    }
    const path = '/api/ws-permissions/companies/{id}/managing-companies-names'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/companies/{id}/managing-companies-names'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.permissions !== undefined) {
        urlParams.append('permissions', params.permissions.toString());
    }
    {
        const value = queryDefaults === false ? params.keepCompanyId : (params.keepCompanyId ?? queryDefaults?.['keepCompanyId']);
        if (value !== undefined) {
            urlParams.append('keepCompanyId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllManagingCompaniesNames.paramsOrder = [{ type: 'parameters' }];
export const getManagedByCompany = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.permission === undefined) {
        throw new Error('Missing required parameter: permission');
    }
    const path = '/api/ws-permissions/companies/{companyId}/permissions/managed-by'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    const pathInternal = '/api/companies/{companyId}/permissions/managed-by'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.permission !== undefined) {
        urlParams.append('permission', params.permission.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getManagedByCompany.paramsOrder = [{ type: 'parameters' }];
export const getCompanyPermissionsSummary = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.userId === undefined) {
        throw new Error('Missing required parameter: userId');
    }
    const path = '/api/ws-permissions/companies/{companyId}/permissions/summary'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    const pathInternal = '/api/companies/{companyId}/permissions/summary'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.userId !== undefined) {
        urlParams.append('userId', params.userId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyPermissionsSummary.paramsOrder = [{ type: 'parameters' }];
export const getUserHeaderHash = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.userId === undefined) {
        throw new Error('Missing required parameter: userId');
    }
    const path = '/api/ws-permissions/companies/{companyId}/permissions/summary/hash'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    const pathInternal = '/api/companies/{companyId}/permissions/summary/hash'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.userId !== undefined) {
        urlParams.append('userId', params.userId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUserHeaderHash.paramsOrder = [{ type: 'parameters' }];
export const getPermittedWebsiteCompanyIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-permissions/websites/{websiteId}/company-ids'.replaceAll('{websiteId}', () => encodeURIComponent(String(params.websiteId)));
    const pathInternal = '/api/websites/{websiteId}/company-ids'.replaceAll('{websiteId}', () => encodeURIComponent(String(params.websiteId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPermittedWebsiteCompanyIds.paramsOrder = [{ type: 'parameters' }];
export const getPaginatedCompaniesNames = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-permissions/company/names/paginated';
    const pathInternal = '/api/company/names/paginated';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.size : (params.size ?? queryDefaults?.['size']);
        if (value !== undefined) {
            urlParams.append('size', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sortDirection : (params.sortDirection ?? queryDefaults?.['sortDirection']);
        if (value !== undefined) {
            urlParams.append('sortDirection', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sortProperties : (params.sortProperties ?? queryDefaults?.['sortProperties']);
        if (value !== undefined) {
            urlParams.append('sortProperties', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPaginatedCompaniesNames.paramsOrder = [{ type: 'parameters' }];
export const getPermissionTypes = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-permissions/permission-types';
    const pathInternal = '/api/permission-types';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPermissionTypes.paramsOrder = [];
export const getCompanyPermissionTypes = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-permissions/companies/{companyId}/permission-types'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    const pathInternal = '/api/companies/{companyId}/permission-types'.replaceAll('{companyId}', () => encodeURIComponent(String(params.companyId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyPermissionTypes.paramsOrder = [{ type: 'parameters' }];
export const getCompanyIdsWithActivePermissions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.permission === undefined) {
        throw new Error('Missing required parameter: permission');
    }
    const path = '/api/ws-permissions/permissions/company-ids';
    const pathInternal = '/api/permissions/company-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.permission !== undefined) {
        urlParams.append('permission', params.permission.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyIdsWithActivePermissions.paramsOrder = [{ type: 'parameters' }];
export const getAccounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-permissions/accounts';
    const pathInternal = '/api/accounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.nameFilter : (params.nameFilter ?? queryDefaults?.['nameFilter']);
        if (value !== undefined) {
            urlParams.append('nameFilter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAccounts.paramsOrder = [{ type: 'parameters' }];
export const getAccountsByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountIds === undefined) {
        throw new Error('Missing required body: accountIds');
    }
    const path = '/api/ws-permissions/accounts/by-ids';
    const pathInternal = '/api/accounts/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountIds !== undefined) {
        body = params.accountIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAccountsByIds.paramsOrder = [{ type: 'body', paramName: 'accountIds' }];
/** Replace old account id with new one. */ export const replaceAccountId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.newAccountId === undefined) {
        throw new Error('Missing required parameter: newAccountId');
    }
    const path = '/api/ws-permissions/accounts/replace-account-id';
    const pathInternal = '/api/accounts/replace-account-id';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.newAccountId !== undefined) {
        urlParams.append('newAccountId', params.newAccountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
replaceAccountId.paramsOrder = [{ type: 'parameters' }];
/** Get list of user groups */ export const getUserGroups = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-permissions/user-groups';
    const pathInternal = '/api/user-groups';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    {
        const value = queryDefaults === false ? params.search : (params.search ?? queryDefaults?.['search']);
        if (value !== undefined) {
            urlParams.append('search', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUserGroups.paramsOrder = [{ type: 'parameters' }];
/** Create user group */ export const createUserGroup = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-permissions/user-groups';
    const pathInternal = '/api/user-groups';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createUserGroup.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Update user group */ export const updateUserGroup = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-permissions/user-groups/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/user-groups/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateUserGroup.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Delete user group */ export const deleteUserGroup = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-permissions/user-groups/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/user-groups/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteUserGroup.paramsOrder = [{ type: 'parameters' }];
/** Update user group */ export const enableUserGroup = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.status === undefined) {
        throw new Error('Missing required parameter: status');
    }
    const path = '/api/ws-permissions/user-groups/{id}/enable'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/user-groups/{id}/enable'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.status !== undefined) {
        urlParams.append('status', params.status.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
enableUserGroup.paramsOrder = [{ type: 'parameters' }];
/** Get list of user groups for selected user */ export const getGroupsByUser = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.userId === undefined) {
        throw new Error('Missing required parameter: userId');
    }
    const path = '/api/ws-permissions/user-groups/by-user';
    const pathInternal = '/api/user-groups/by-user';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.userId !== undefined) {
        urlParams.append('userId', params.userId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getGroupsByUser.paramsOrder = [{ type: 'parameters' }];
/** Assign user groups to a user */ export const assignUserGroups = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.userGroupIds === undefined) {
        throw new Error('Missing required body: userGroupIds');
    }
    if (params.userId === undefined) {
        throw new Error('Missing required parameter: userId');
    }
    const path = '/api/ws-permissions/user-groups/by-user';
    const pathInternal = '/api/user-groups/by-user';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.userGroupIds !== undefined) {
        body = params.userGroupIds;
    }
    if (params.userId !== undefined) {
        urlParams.append('userId', params.userId.toString());
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
assignUserGroups.paramsOrder = [{ type: 'body', paramName: 'userGroupIds' }, { type: 'parameters' }];
export * from './types';
export * from './constants';
